import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  buttonWrap: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    marginBottom: '10px',
    fontDefault: 14,
    lineHeight: '16px',
    color: colors.space60,
  },

  buttonWrap: {
    flexDirection: 'row',
    marginTop: '11px',
  },
});

export default styles;
